export const regionCountryCodeMapping = {
  ASIA: [
    'AFG',
    'ARM',
    'AZE',
    'BHR',
    'BGD',
    'BTN',
    'BRN',
    'KHM',
    'CHN',
    'CXR',
    'CCK',
    'IOT',
    'GEO',
    'HKG',
    'IND',
    'IDN',
    'IRN',
    'IRQ',
    'ISR',
    'JPN',
    'JOR',
    'KAZ',
    'KWT',
    'KGZ',
    'LAO',
    'LBN',
    'MAC',
    'MYS',
    'MDV',
    'MNG',
    'MMR',
    'NPL',
    'PRK',
    'OMN',
    'PAK',
    'PSE',
    'PHL',
    'QAT',
    'SAU',
    'SGP',
    'KOR',
    'LKA',
    'SYR',
    'TWN',
    'TJK',
    'THA',
    'TLS',
    'TUR',
    'TKM',
    'ARE',
    'UZB',
    'VNM',
    'YEM',
  ],
  EUROPE: [
    'ALA',
    'ALB',
    'AND',
    'AUT',
    'BLR',
    'BEL',
    'BIH',
    'BGR',
    'HRV',
    'CYP',
    'CZE',
    'DNK',
    'EST',
    'FRO',
    'FIN',
    'FRA',
    'DEU',
    'GIB',
    'GRC',
    'GGY',
    'HUN',
    'ISL',
    'IRL',
    'IMN',
    'ITA',
    'JEY',
    'KOS',
    'LVA',
    'LIE',
    'LTU',
    'LUX',
    'MLT',
    'MDA',
    'MCO',
    'MNE',
    'NLD',
    'MKD',
    'NOR',
    'POL',
    'PRT',
    'ROU',
    'RUS',
    'SMR',
    'SRB',
    'SVK',
    'SVN',
    'ESP',
    'SWE',
    'CHE',
    'UKR',
    // Is UK part of EUROPE?
    //'GBR',
    'VAT',
  ],
  MIDDLE_EAST: [
    'BHR',
    'IRN',
    'IRQ',
    'ISR',
    'JOR',
    'KWT',
    'LBN',
    'OMN',
    'QAT',
    'SAU',
    'PSE',
    'SYR',
    'TUR',
    'ARE',
    'YEM',
  ],
  OCEANIA: [
    'ASM',
    'AUS',
    'COK',
    'FJI',
    'PYF',
    'GUM',
    'KIR',
    'MNP',
    'MHL',
    'FSM',
    'NRU',
    'NCL',
    'NZL',
    'NIU',
    'NFK',
    'MNP',
    'PLW',
    'PNG',
    'PCN',
    'WSM',
    'SLB',
    'TKL',
    'TON',
    'TUV',
    'VUT',
    'WLF',
  ],
  NORTH_AMERICA: [
    'ATG',
    'BHS',
    'BRB',
    'BLZ',
    'CAN',
    'CYM',
    'CRI',
    'CUB',
    'CUW',
    'DMA',
    'DOM',
    'SLV',
    'GRL',
    'GRD',
    'GLP',
    'GTM',
    'HTI',
    'HND',
    'JAM',
    'MTQ',
    'MEX',
    'SPM',
    'MSR',
    'ANT',
    'KNA',
    'NIC',
    'PAN',
    'PRI',
    'BES',
    'BES',
    'LCA',
    'MAF',
    'VCT',
    'SXM',
    'TTO',
    'TCA',
    'USA',
    'VIR',
  ],
  UK: ['GBR'],
};
